__turbopack_context__.v({
  "add-to-wishlist-btn": "ZkP1Va_add-to-wishlist-btn",
  "details-container": "ZkP1Va_details-container",
  "has-custom-text": "ZkP1Va_has-custom-text",
  "instant-add-btn-mobile": "ZkP1Va_instant-add-btn-mobile",
  "instant-add-with-options": "ZkP1Va_instant-add-with-options",
  "instantadd-button-disabled": "ZkP1Va_instantadd-button-disabled",
  "price-per-unit-cont": "ZkP1Va_price-per-unit-cont",
  "product-badge": "ZkP1Va_product-badge",
  "product-badge-caption": "ZkP1Va_product-badge-caption",
  "product-badge-low-stock": "ZkP1Va_product-badge-low-stock",
  "product-custom-text": "ZkP1Va_product-custom-text",
  "product-details": "ZkP1Va_product-details",
  "product-name": "ZkP1Va_product-name",
  "productimage-block": "ZkP1Va_productimage-block",
  "productimg-link": "ZkP1Va_productimg-link",
  "productimg-secondary": "ZkP1Va_productimg-secondary",
  "productimg-slider": "ZkP1Va_productimg-slider",
  "productitem-block": "ZkP1Va_productitem-block",
  "productitem-instant-add": "ZkP1Va_productitem-instant-add",
  "productitem-instant-add-options": "ZkP1Va_productitem-instant-add-options",
  "productname-link": "ZkP1Va_productname-link",
  "size-disabled": "ZkP1Va_size-disabled",
  "tile-rating-container": "ZkP1Va_tile-rating-container",
  "tile-rating-inline": "ZkP1Va_tile-rating-inline",
});
